export const AUTHOR_PREFIX = 'Author: '
export const ILLUSTRATOR_PREFIX = 'Illustrator: '
